<template>
  <span
    v-html="message"
  ></span>
</template>

<script>
export default {
  props: {
    message: { type: String, default: 'text' },
  },
  data() {
    return {
      locales: __,
    };
  },
};
</script>
